import { motion } from "framer-motion";
import { MANIFESTO } from "@/lib/data";
import { Reveal, SectionLabel } from "@/components/Reveal";

export const Manifesto = () => (
  <section id="manifesto" className="relative border-y border-[var(--border-subtle)] bg-[var(--bg-secondary)]">
    <div className="mx-auto max-w-[1400px] px-6 sm:px-10 py-24 lg:py-36">
      <Reveal>
        <SectionLabel>The manifesto</SectionLabel>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.02] max-w-3xl mb-16">
          How we think about <span className="text-gradient">the work.</span>
        </h2>
      </Reveal>

      <div className="space-y-2">
        {MANIFESTO.map((c, i) => (
          <motion.div
            key={c.no}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.1 }}
            className="group grid md:grid-cols-[auto_1fr] gap-6 md:gap-12 items-start border-t border-[var(--border-subtle)] py-10 transition-colors hover:bg-[var(--bg-tertiary)]/40 rounded-2xl px-2 md:px-6"
          >
            <span className="font-display text-6xl md:text-7xl font-extrabold text-gradient leading-none">{c.no}</span>
            <div className="max-w-2xl">
              <h3 className="font-display text-2xl md:text-3xl font-bold mb-3 transition-transform duration-500 group-hover:translate-x-2">{c.title}</h3>
              <p className="font-body text-[var(--text-secondary)] text-base md:text-lg leading-relaxed">{c.body}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
